<template>
    <div class="pa-5" v-if="activeTag">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Assign clients" | t }}</v-col>
            <v-col cols="9">
                <v-autocomplete
                    v-model="selectedClientIds"
                    :items="availableClients"
                    item-text="shop_name"
                    item-value="id"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    dense
                    outlined
                    hide-details
                    :placeholder="t('Search and select clients')"
                    :loading="isLoading"
                />
            </v-col>
        </v-row>

        <v-divider class="my-4" />

        <div class="subtitle-1 mb-2">{{ "Assigned clients" | t }} ({{ (activeTag.clients || []).length }})</div>
        <v-data-table
            :headers="tableHeaders"
            :items="activeTag.clients || []"
            :items-per-page="25"
            :footer-props="footerProps"
            dense
            class="clients-table"
        >
            <template v-slot:item="{ item }">
                <tr>
                    <td>{{ item.name || "-" }}</td>
                    <td>{{ item.chain_name || "-" }}</td>
                    <td>{{ item.shop_name || "-" }}</td>
                    <td class="text-right">
                        <v-btn icon small @click="removeClient(item.id)" color="error">
                            <v-icon small>close</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:no-data>
                <div class="text-center pa-4">{{ "No clients assigned" | t }}</div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import Store from "@/store";

export default {
    name: "clients-edit-tab",
    data() {
        return {
            isLoading: false,
            footerProps: { "items-per-page-options": [10, 25, 50] },
            tableHeaders: [
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "name"
                },
                {
                    text: this.t("Chain name"),
                    align: "left",
                    value: "chain_name"
                },
                {
                    text: this.t("Shop name"),
                    align: "left",
                    value: "shop_name"
                },
                {
                    text: "",
                    align: "right",
                    value: "actions",
                    sortable: false,
                    width: "50px"
                }
            ]
        };
    },
    async mounted() {
        this.isLoading = true;
        if (!this.clients_all || this.clients_all.length === 0) {
            await this.getFrequentlyUsedQueries({ clients_all: true });
        }
        this.isLoading = false;
    },
    computed: {
        ...mapState(["clients_all"]),
        ...mapState("TagStore", ["activeTag"]),
        availableClients() {
            return this.clients_all || [];
        },
        selectedClientIds: {
            get() {
                return (this.activeTag.clients || []).map(c => c.id);
            },
            set(val) {
                this.updateClientIds(val);
            }
        }
    },
    methods: {
        ...mapMutations("TagStore", ["updateActiveTagProperty"]),
        ...mapActions(["getFrequentlyUsedQueries"]),
        updateClientIds(ids) {
            // Update client_ids in activeTag
            this.updateActiveTagProperty({ prop: "client_ids", value: ids });

            // Also update the clients array for display
            const newClients = ids.map(id => {
                const existingClient = (this.activeTag.clients || []).find(c => c.id === id);
                if (existingClient) {
                    return existingClient;
                }
                const client = this.clients_all.find(c => c.id === id);
                return client ? {
                    id: client.id,
                    name: client.name,
                    chain_name: client.chain_name,
                    shop_name: client.shop_name
                } : null;
            }).filter(c => c !== null);

            this.updateActiveTagProperty({ prop: "clients", value: newClients });
        },
        removeClient(clientId) {
            const newIds = this.selectedClientIds.filter(id => id !== clientId);
            this.updateClientIds(newIds);
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
.clients-table tr:hover {
    background-color: #f5f5f5;
}
</style>
